import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.4144 7.00003L9.00015 18.4142L3.58594 13L5.00015 11.5858L9.00015 15.5858L19.0002 5.58582L20.4144 7.00003Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgCheckmark);
export default ForwardRef;
